import { urlServices } from "./param-url.constants";

export const urlServicesAuth = {
    //api/authentications/users/access
    auth: urlServices.urlServiceAuth + 'users/access',
    //api/authentications/users/refresh
    refresh: urlServices.urlServiceAuth + 'users/refresh',
    
    doubleSignature : urlServices.urlServiceAuth + 'sign/doubleSignature'
};